<template>
  <div class="online">
    <!-- 加载中 -->
    <div class="cover-wrap" v-show="loading_switch"></div>
    <div class="loading-box" v-show="loading_switch">
      <van-loading vertical class="loading" color="#fff">{{ loading_tip }}</van-loading>
    </div>

    <div class="content-wrap" v-show="statue == 'pending'">
      <div class="big-title">退款及取消自动续费</div>
      <div class="info1">您可通过此页面查询您在我们APP中订阅的会员服务，自助退款并取消自动续费。</div>
      <div class="phone-lable">请输入您开通会员时绑定的手机号</div>
      <div class="phone-input">
        <input type="number" placeholder="将查询此手机号账户的可退款订单" v-model="phone" :class="{ act: ishas }" />
      </div>
      <!-- <div class="order-num-box" @click="showPicker = true">
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1">一共有1笔订单需要退款</van-radio>
          <van-radio name="2">一共有多笔订单需要退款</van-radio>
        </van-radio-group>
      </div> -->
      <div class="phone-btn" @click="handleCustomerAutoRefund()">查询订单并退款</div>
    </div>

    <div class="content-wrap" v-show="statue == 'fulfilled'">
      <div class="big-title">退款及取消自动续费</div>
      <div class="fulfilled-tip">请选择要退款的订单</div>
      <div class="fulfilled-res">
        <div :class="{ 'res-item': true, act: item.isChecked }" @click="handleIsChecked(index)" v-for="(item, index) in orderList" :key="index">
          <div class="item-l">
            <div class="l-info">{{ item.platform }} ({{ item.spec_dx }})</div>
            <div class="l-time">{{ item.pay_time }}</div>
          </div>
          <div class="item-r">-{{ item.pay_price }}元</div>
          <div class="item-act" v-show="item.isChecked">
            <img src="../../assets/image/order_act.png" alt="act" />
          </div>
        </div>
      </div>

      <div :class="{ 'fulfilled-btn': true, act: btnStatue }" @click="handleRefund()">一键退款并关闭自动续费</div>
      <div class="tips-box">
        <div class="font-tips" ref="elementToObserve">温馨提示：</div>
        <div class="font-tips">退款后，将同时关闭自动续费服务，不会再继续扣费。同时，您订阅的会员服务将被取消。</div>
      </div>
    </div>

    <div class="content-wrap" style="background-color: #fff" v-show="statue == 'rejected'">
      <div class="submit-info1">
        <img src="../../assets/image/error.png" alt="complete" />
      </div>
      <div class="submit-info2">未查询到可退订单</div>
      <div class="submit-info3">您可能未在APP内绑定该手机号。请不要担心，点击下方按钮联系400客服，我们会快速为您解决退款问题。</div>
      <a href="tel:4007752588" @click="reportEvent()">
        <div class="rejected-btn">
          <div class="btn-icon">
            <img src="../../assets/image/phone.png" alt="phone" />
          </div>
          <div class="btn-text">联系 400 官方客服</div>
        </div>
      </a>
      <div class="submit-info4">客服热线：400-755-2588</div>
    </div>

    <div class="content-wrap" style="background-color: #fff" v-show="statue == 'err'">
      <div class="submit-info1">
        <img src="../../assets/image/complete.png" alt="complete" />
      </div>
      <div class="submit-info2">提交成功</div>
      <div class="submit-info3">您的退款将在1个工作日内到账。请耐心等待。</div>
      <div class="submit-info3" style="margin-top:10px">如有其他问题，请点击下方按钮，拨打客服热线4007752588，我们将竭诚为您解决问题。</div>
      <a href="tel:4007752588" @click="reportEvent()">
        <div class="rejected-btn">
          <div class="btn-icon">
            <img src="../../assets/image/phone.png" alt="phone" />
          </div>
          <div class="btn-text">联系 400 官方客服</div>
        </div>
      </a>
      <div class="submit-info4">客服热线：400-755-2588</div>
    </div>

    

    <div class="content-wrap1" v-show="statue == 'succ'">
      <div class="big-title">退款及取消自动续费</div>
      <div class="info1" v-show="report_list && report_list.success && report_list.success.length">
        <div class="icon">
          <img src="../../assets/image/dui.png" alt="dui" />
        </div>
        <div class="font">下列订单已原路退款成功</div>
      </div>
      <div class="info2">
        <div class="item" v-for="(item, index) in report_list.success" :key="index">
          <div class="item-l">
            <div class="l-info">{{ item.transaction_id }}</div>
            <div class="l-time">{{ item.paytime }}</div>
          </div>
          <div class="item-r">{{ item.price }}元</div>
        </div>
      </div>
      <div class="info3" v-show="report_list && report_list.fail && report_list.fail.length">
        <div class="icon">
          <img src="../../assets/image/error.png" alt="dui" />
        </div>
        <div class="font">下列订单退款失败</div>
      </div>
      <div class="info4" v-show="report_list && report_list.fail && report_list.fail.length">下列订单原路退款出现异常，请您拨打客服热线400-775-2588，联系工作人员为您转账退款。退款金额将在24小时内转到您的账户上。请务必放心。</div>
      <div class="info5" v-show="report_list && report_list.fail && report_list.fail.length">
        <div class="item" v-for="(item, index) in report_list.fail" :key="index">
          <div class="item-l">
            <div class="l-info">{{ item.transaction_id }}</div>
            <div class="l-time">{{ item.paytime }}</div>
          </div>
          <div class="item-r">{{ item.price }}元</div>
        </div>
      </div>
      <div class="info6" ref="elementToObserve1">
        <div class="title">
          <div class="icon">
            <img src="../../assets/image/dui.png" alt="dui" />
          </div>
          <div class="font">自动续费服务已经关闭，不会再产生扣费</div>
        </div>
        <div class="tips">如有更多问题，可联系客服热线400-775-2588</div>

        <a href="tel:4007752588" @click="reportEvent()">
        <div class="rejected-btn">
          <div class="btn-icon">
            <img src="../../assets/image/phone.png" alt="phone" />
          </div>
          <div class="btn-text">联系 400 官方客服</div>
        </div>
      </a>
      </div>
    </div>

    <!-- 常见问题 -->
    <div class="q-wrap">
      <div class="title">常见问题</div>
      <div class="option">
        <div class="option-title">1、为什么被扣款了？</div>
        <div class="option-content"><span class="ospan1"></span><span class="ospan2">本APP的自动续费扣款是因为您之前有开通了本产品的试用，同时授权同意了自动续费协议，试用期间可随时取消，试用到期后会按照自动续费协议进行续费，所以才产生这笔续费会员的扣款。</span></div>
      </div>

      <div class="option">
        <div class="option-title">2、退款后还会再扣款吗？</div>
        <div class="option-content"><span class="ospan1"></span><span class="ospan2">退款后，自动续费服务将关闭，不会再自动扣款。</span></div>
      </div>

      <div class="option">
        <div class="option-title">3、取消订阅后，还能使用APP吗？</div>
        <div class="option-content"><span class="ospan1"></span><span class="ospan2">取消订阅后，您可继续使用APP的免费功能，但会员特权将会失效，如需重新开通会员，请在APP内点击“我的”-“开通超级会员”。</span></div>
      </div>

      <div class="option">
        <div class="option-title">4、钱会退到哪里？</div>
        <div class="option-content"><span class="ospan1"></span><span class="ospan2">您提交后，款项将原路退回到您的支付账户。请注意查看支付宝信息。</span></div>
      </div>
    </div>

   
  </div>
</template>

<script>
import {
  ApiCustomerAutoRefund,
} from "@/api/customer.js";
export default {
  name: 'OnlineView',
  data() {
    return {
      loading_switch: false,
      phone: '',
      ishas: false,

      orderList: [],
      report_list: {},
      statue: 'pending', //rejected-失败；fulfilled-成功；pending-查询中；succ - 成功退款；err - 退款进行中206
      btnStatue: false,
      loading_tip: '正在查询订单，请稍候...',

      radio: '1',
      timer1: null,

    };
  },
  created() {
    this.statue = sessionStorage.getItem('statue') || 'pending';
    this.btnStatue = Boolean(sessionStorage.getItem('btnStatue')) || false;
    this.orderList = JSON.parse(sessionStorage.getItem('orderList')) || [];
    this.report_list = JSON.parse(sessionStorage.getItem('report_list')) || {};
  },
  
  destroyed() {
    sessionStorage.removeItem('statue');
    sessionStorage.removeItem('btnStatue');
    sessionStorage.removeItem('orderList');
    sessionStorage.removeItem('report_list');
    clearTimeout(this.timer1);
  },

  watch: {
    phone() {
      if (this.phone) {
        this.ishas = false;
      }
    },
    statue() {
      window.scrollTo(0,0);
    },
  },
  methods: {
    // 查询订单并退款（包含php和java双平台）
    handleCustomerAutoRefund() {
      this.handleRefundEventReport();

      if (!this.phone) {
        window.scrollTo(0, 0);
        this.ishas = true;
        this.$toast('请填写手机号');
        return;
      }

      if (this.phone.length != 11) {
        window.scrollTo(0, 0);
        this.ishas = true;
        this.$toast('联系方式不合法');
        return;
      }

      this.loading_tip = "正在查询订单，请稍候...";
      this.loading_switch = true;
      localStorage.setItem("phone", this.phone);
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.loading_tip = "全力查询中，预计需要几秒钟，请稍等...";
      }, 2000);

      ApiCustomerAutoRefund({
        contact: this.phone,
        originMerchName: '',
        originType: 4,
        onlyOne: 1,
        from: "mangxian_h5",
        isAutoRefund: 4,
      })
        .then((res) => {
          this.loading_switch = false;

          if (res.code == 206) {
            this.statue = "err";
            sessionStorage.setItem("statue", this.statue);
            return;
          }

          if (res.code !== 0) {
            this.statue = 'rejected';
            sessionStorage.setItem('statue', this.statue);
            return;
          }

          const resultData = res.data;

          // php处理逻辑
          if (resultData.phpOrders && resultData.phpOrders.length) {
            this.reportAutoRefund()
            const phpOrder = resultData.phpOrders[0];

            this.report_list = {
              success: [
                {
                  transaction_id: phpOrder.transactionId,
                  paytime: phpOrder.payTime,
                  price: phpOrder.price,
                },
              ],
              fail: [],
            };
            this.statue = 'succ';
            sessionStorage.setItem('statue', this.statue);
            sessionStorage.setItem('report_list', JSON.stringify(this.report_list));
            return;
          }

          // java处理逻辑
          if (resultData.javaOrders && resultData.javaOrders.length) {
            this.report_list = {
              success: [],
              fail: [],
            };

            resultData.javaOrders.forEach((item, index) => {
              if (item.refunded) {
                this.report_list.success.push({
                  transaction_id: `${item.applicationName}(${item.goodsPackageName})`,
                  paytime: item.payTime,
                  price: item.refundableAmount,
                });
              } else {
                this.report_list.fail.push({
                  transaction_id: `${item.applicationName}(${item.goodsPackageName})`,
                  paytime: item.payTime,
                  price: item.refundableAmount,
                });
              }
            });
            // 存储结果并跳转
            this.statue = 'succ';
            sessionStorage.setItem('statue', this.statue);
            sessionStorage.setItem('report_list', JSON.stringify(this.report_list));
            return;
          }

            // javaOrders和phpOrders都为空
            this.statue = "err";
            sessionStorage.setItem("statue", this.statue);
        })
        .catch(() => {
          this.loading_switch = false;
          this.statue = 'rejected';
          sessionStorage.setItem('statue', this.statue);
        });
    },
    // ===================================================
    //查询订单并退款
    async handleSubmitForm() {

      if (!this.phone) {
        window.scrollTo(0, 0);
        this.ishas = true;
        this.$toast('请填写手机号');
        return;
      }

      if (this.phone.length != 11) {
        window.scrollTo(0, 0);
        this.ishas = true;
        this.$toast('联系方式不合法');
        return;
      }

      this.loading_tip = '正在查询订单，请稍候...';
      this.loading_switch = true;

      let only_one = '1';
      if (this.radio == '2') {
        only_one = '0';
      }
      let res = await this.$axios
        .post('https://middlegrounpcomplaint.juzan.info/api/order/searchByPhoneWithRefundReport', {
          phone: this.phone,
          only_one,
          // from: 'qyrobot' // 七鱼机器人h5
        })
        .catch((err) => {
          this.loading_switch = false;
          this.statue = 'rejected';
          sessionStorage.setItem('statue', this.statue);
        });
      let findRes = res.data;
      // console.log('查询结果==>', findRes);
      if (findRes.code == 200) {
        //200 - 成功获取订单
        this.loading_switch = false;
        if (findRes.data.is_reprot == 0) {
          this.orderList = [];
          findRes.data.refund_list.forEach((item, index) => {
            item.isChecked = true;
            item.pay_time = this.getFormattedDate(item.pay_time);
            if (item.spec_dx >= 36000) {
              item.spec_dx = '终身卡';
            } else {
              item.spec_dx = item.spec_dx + '天';
            }
            this.orderList.push(item);
          });
          this.btnStatue = true;
          this.statue = 'fulfilled';
          sessionStorage.setItem('statue', this.statue);
          sessionStorage.setItem('btnStatue', this.btnStatue);
          sessionStorage.setItem('orderList', JSON.stringify(this.orderList));
        } else if (findRes.data.is_reprot == 1) {
          this.reportAutoRefund();
          let successArr = [];
          let failArr = [];
          findRes.data.report_list.success.forEach((item, index) => {
            item.paytime = this.getFormattedDate(item.paytime);
            successArr.push(item);
          });

          findRes.data.report_list.fail.forEach((item, index) => {
            item.paytime = this.getFormattedDate(item.paytime);
            failArr.push(item);
          });

          this.report_list = {
            success: successArr,
            fail: failArr,
          };
          this.statue = 'succ';
          sessionStorage.setItem('statue', this.statue);
          sessionStorage.setItem('report_list', JSON.stringify(this.report_list));
        }
      } else if (findRes.code == 204) {
        //204 - 未获取到订单数据
        this.loading_switch = false;
        this.statue = 'rejected';
        sessionStorage.setItem('statue', this.statue);
      } else {
        //400 - 参数异常
        this.loading_switch = false;
        this.statue = 'rejected';
        sessionStorage.setItem('statue', this.statue);
      }
    },

    //返回上一个页面
    handleBack() {
      if (this.statue == 'rejected') {
        this.statue = 'pending';
        sessionStorage.setItem('statue', this.statue);
      } else if (this.statue == 'fulfilled') {
        this.statue = 'pending';
        sessionStorage.setItem('statue', this.statue);
      } else if (this.statue == 'pending') {
        this.$router.go(-1);
      } else if (this.statue == 'succ') {
        this.$router.go(-1);
      }else if (this.statue == 'err') {
        this.$router.go(-1);
      }
      window.scrollTo(0, 0);
    },

    //选择订单
    handleIsChecked(index) {
      this.orderList[index].isChecked = !this.orderList[index].isChecked;
      let num = 0;
      this.orderList.forEach((item, index) => {
        if (item.isChecked) {
          num++;
        }
      });

      this.btnStatue = num > 0 ? true : false;

      sessionStorage.setItem('btnStatue', this.btnStatue);
      sessionStorage.setItem('orderList', JSON.stringify(this.orderList));
    },

    //一键退款并关闭自动续费
    async handleRefund() {
      if (!this.btnStatue) {
        return;
      }
      this.loading_tip = '系统处理中，请勿离开本页面';
      this.loading_switch = true;

      let actOrder = [];
      this.orderList.forEach((item, index) => {
        if (item.isChecked) {
          let obj = {};
          obj.platform = item.platform_id;
          obj.order_no = item.order_no;
          actOrder.push(obj);
        }
      });
      // console.log("选中退款订单",actOrder);

      //执行退款操作
      let res = await this.$axios
        .post('https://middlegrounpcomplaint.juzan.info/api/order/submitRefundWithAutoRefund', {
          phone: this.phone,
          refund_list: actOrder,
          is_auto_refund: 4,// 4-忙线，11-七鱼机器人h5
        })
        .catch((err) => {
          this.loading_switch = false;
          this.statue = 'rejected';
          sessionStorage.setItem('statue', this.statue);
        });
      let subRes = res.data;
      // console.log('查询结果==>', subRes);

      if (subRes.code == 200) {
        this.loading_switch = false;
        this.reportAutoRefund();
        let successArr = [];
        let failArr = [];
        subRes.data.success.forEach((item, index) => {
          item.paytime = this.getFormattedDate(item.paytime);
          successArr.push(item);
        });

        subRes.data.fail.forEach((item, index) => {
          item.paytime = this.getFormattedDate(item.paytime);
          failArr.push(item);
        });

        this.report_list = {
          success: successArr,
          fail: failArr,
        };
        this.statue = 'succ';
        sessionStorage.setItem('statue', this.statue);
        sessionStorage.setItem('report_list', JSON.stringify(this.report_list));
      } else if (subRes.code == 206) {
        this.reportAutoRefund();
        this.loading_switch = false;
        this.statue = "err";
        sessionStorage.setItem("statue", this.statue);
      } else {
        this.reportAutoRefund();
        this.loading_switch = false;
        this.statue = 'rejected';
        sessionStorage.setItem('statue', this.statue);
        // this.$toast('该订单在线退款失败，请选择电话极速退款');
      }
    },

    // 格式化时间戳
    getFormattedDate(time) {
      const timestamp = time * 1000; // 待转换的时间戳
      const date = new Date(timestamp); // 根据时间戳创建Date对象
      const year = date.getFullYear(); // 获取年份
      const month = date.getMonth() + 1; // 获取月份，需要加1
      const day = date.getDate(); // 获取日期
      let hour = date.getHours(); // 获取小时
      hour = hour < 10 ? '0' + hour : hour;
      let minute = date.getMinutes(); // 获取分钟
      minute = minute < 10 ? '0' + minute : minute;
      let second = date.getSeconds(); // 获取秒数
      second = second < 10 ? '0' + second : second;
      const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`; // 拼接成格式化后的日期字符串

      return formattedDate;
    },


    //上报
    async reportAutoRefund() {
      let res = await this.$axios.get('https://middlegrounpcomplaint.juzan.info/api/order/reportAutoRefund', {
        headers: {
          Authorization: this.phone,
        },
      });
      // console.log('上报状态', res);
    },

    //埋点数据上报
    async reportEvent() {
      let taskId = localStorage.getItem('taskId');
      let res = await this.$axios.post('https://middlegrounpcomplaint.juzan.info/api/event/index', {
        event: 'cs_click',
        attr: '1',
        c_no: taskId,
        source: 4,
      });
    },
     // 事件上报--点击在线退款
    async handleRefundEventReport() {
      let taskId = localStorage.getItem('taskId');
      let res = await this.$axios.post('https://middlegrounpcomplaint.juzan.info/api/event/index', {
        event: 'refund_button_click',
        attr: '1',
        c_no: taskId,
        source: 4,
      });
    },
  },
};
</script>

<style lang="less">
@import url('./online.less');
</style>
